<div>
  <div class="bg-custom">
    <div class="container">
      @if (!submissionStatusSwitch) {
        <p>{{'MY_SUBMISSION_STATIC_1' | globalTranslate }}</p>
      }
      @if (submissionStatusSwitch) {
        <p>{{'MY_SUBMISSION_STATIC_1' | globalTranslate }}{{'GO_TO' | globalTranslate}}<a class="add-primary-color" role="link" tabindex="0" (click)="goToSubmissionStatus()" (keydown.enter)="goToSubmissionStatus()" (keydown.space)="goToSubmissionStatus(); $event.preventDefault()"
          >{{'APPLICATION_STATUS' | globalTranslate }}</a><span>{{'MY_SUBMISSION_STATIC_34' | globalTranslate}}</span></p>
        }
        <section>
          <div>
            <h1 class="section-header">{{'MY_SUBMISSION_STATIC_2' | globalTranslate }}</h1>
            <hr>
              @if (!isLinkedAcc && !isPartnerPortal) {
                <section>
                  <p>{{'MY_SUBMISSION_STATIC_4' | globalTranslate }}<a [routerLink]="['/user-profile', 'case-link']">{{'LINK_CASE_TITLE' | globalTranslate }}</a> {{'MY_SUBMISSION_STATIC_5' | globalTranslate }}</p>
                </section>
              }
              @if ((hoh && showSubmitRenewalMessage && (daysAfterRenewal > 90))) {
                <p>{{'MY_SUBMISSION_STATIC_3' | globalTranslate }} </p>
              }
              @if ((!hoh && isLinkedAcc) && !isPartnerPortal) {
                <p>{{'MY_SUBMISSION_STATIC_6' | globalTranslate }}</p>
              }
              @if ((hoh && renewalDisable && (daysPastRenewalDueDate <= 90))) {
                <p>{{'MY_SUBMISSION_STATIC_7' | globalTranslate }} <a tabindex="0" (click)="renewBenefits()">{{'RENEW_MY_COVERAGE' | globalTranslate}}.</a></p>
              }
              @if (false) {
                <p>{{'MY_SUBMISSION_STATIC_8' | globalTranslate }}<a href="">{{'RENEW_MY_COVERAGE' | globalTranslate}}</a> {{'MY_SUBMISSION_STATIC_9' | globalTranslate}}</p>
              }
              <!-- @if () {
                <p>You can start renewing your coverage on date. You must submit your renewal by date or your coverage
                may end.</p>
              } -->
              @if (renewals && renewals.length > 0) {
                <p>{{'MY_SUBMISSION_STATIC_10' | globalTranslate }}</p>
              }
              @if (renewals && renewals.length > 0) {
                <p>{{'MY_SUBMISSION_STATIC_11' | globalTranslate }}</p>
              }
              @if (isLinkedAcc && (renewals?.length === 0 || !renewals)) {
                <p>{{'MY_SUBMISSION_STATIC_12' | globalTranslate }}</p>
              }
              @if (renewals && renewals?.length !== 0) {
                <span><br></span>
              }
              @if (renewals?.length > 0) {
                <table class="table">
                  <thead>
                    <tr>
                      <th>{{'Submitted By' | globalTranslate }}</th>
                      <th>{{'MY_SUBMISSION_STATIC_14' | globalTranslate }}</th>
                      <th>{{'Status' | globalTranslate }}</th>
                      <th>{{'Date of Submission' | globalTranslate }}</th>
                      <th>{{'View' | globalTranslate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of renewals; track item) {
                      <tr>
                        <td>{{ item.submittedBy }}</td>
                        <td>@if (item.status === 'SB') {
                          <span>{{ item.wpAppnumber }}</span>
                        }
                        @if (item.status === 'ST') {
                          <span class="hover-red">
                            <a class="text-start p-0 btn btn-link btn-lg hover-red w-100" tabindex="0" (click)="continueRenewal()">
                              <span>{{'COVERAGE_RENEWAL_CONTINUE' | globalTranslate }}</span>
                            </a>
                          </span>
                        }
                      </td>
                      <td>@if (item.status === 'SB') {
                        <div>{{'Submitted' | globalTranslate }}</div>
                      }
                      @if (item.status === 'ST') {
                        <div>{{'In Progress' | globalTranslate }}</div>
                      }
                    </td>
                    <td>@if (item.status === 'SB') {
                      <div>{{ item.submissionDate }}</div>
                    }
                    @if (item.status === 'ST') {
                      <div></div>
                    }
                  </td>
                  <td>
                    @if (item.status === 'SB') {
                      <span class="hover-red">
                        <a class="btn btn-link hover-red" tabindex="0" (click)="onViewApp(item.tccAppnumber)" [attr.aria-label]="'VIEW_APPLICATION' | globalTranslate">
                          <i class="fa fa-search" aria-hidden="true"></i>
                          <span class="sr-only">{{'VIEW_APPLICATION' | globalTranslate }}</span>
                        </a>
                      </span>
                    }
                    @if (item.status === 'ST') {
                      <span></span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </section>

    <section>
      <div>
        <h2 class="indivSw && section-header">{{'MY_SUBMISSION_STATIC_15' | globalTranslate }}</h2>
        <hr>
          @if (!isLinkedAcc && !isPartnerPortal) {
            <section>
              <p>{{'MY_SUBMISSION_STATIC_4' | globalTranslate }} <a [routerLink]="['/user-profile', 'case-link']">{{'LINK_CASE_TITLE' | globalTranslate }}</a> {{'MY_SUBMISSION_STATIC_5' | globalTranslate }}</p>
            </section>
          }
          @if ((!hoh && isLinkedAcc && !isPartnerPortal)) {
            <p>{{'MY_SUBMISSION_STATIC_16' | globalTranslate }}</p>
          }
          @if (reportChanges && reportChanges.length > 0) {
            <p>{{'MY_SUBMISSION_STATIC_17' | globalTranslate }}</p>
          }
          @if (reportChanges && reportChanges.length > 0) {
            <p>{{'MY_SUBMISSION_STATIC_18' | globalTranslate }}</p>
          }
          @if (indivSw && isLinkedAcc && (reportChanges?.length === 0 || !reportChanges)) {
            <p>{{'MY_SUBMISSION_STATIC_19'| globalTranslate }}</p>
          }
          @if (reportChanges?.length > 0) {
            <table class="table">
              <thead>
                <tr>
                  <th>{{'Submitted By' | globalTranslate }}</th>
                  <th>{{'MY_SUBMISSION_STATIC_20' | globalTranslate }}</th>
                  <th>{{'MY_SUBMISSION_STATIC_21' | globalTranslate }}</th>
                  <th>{{'Date of Submission' | globalTranslate }}</th>
                  <th>
                    <span class="visually-hidden">Actions</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (item of reportChanges; track item) {
                  <tr>
                    <td>{{ item.submittedBy }}</td>
                    <td>@if (item.status === 'SB') {
                      <span>{{ item.caseNumber }}</span>
                    }
                    @if (item.status === 'ST') {
                      <span class="hover-red">
                        <span>{{ item.caseNumber }}</span>
                      </span>
                    }
                  </td>
                  <td>
                    @for (change of item.changesArray; track change; let i = $index) {
                      <div>
                        @if (item.typeOfChange && item.typeOfChange !== '') {
                          <span>{{change | globalTranslate }}</span>
                        }
                      </div>
                    }
                    @if (!item.typeOfChange || item.typeOfChange === '') {
                      <div>{{''}}</div>
                    }
                  </td>
                  <td>
                    @if (item.status === 'SB') {
                      <div>{{ item.submissionDate }}</div>
                    }
                    @if (item.status === 'ST') {
                      <div></div>
                    }
                  </td>
                  <td>
                    @if (item.status === 'SB') {
                      <span class="hover-red">
                        <a class="btn btn-link hover-red" tabindex="0" (click)="onViewApp(item.tccAppnumber)" [attr.aria-label]="'VIEW_APPLICATION' | globalTranslate">
                          <i class="fa fa-search" aria-hidden="true"></i>
                          <span class="sr-only">{{'VIEW_APPLICATION' | globalTranslate }}</span>
                        </a>
                      </span>
                    }
                    @if (item.status === 'ST') {
                      <span></span>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      </div>
    </section>
    <!--Eligibility Appeals start-->
    <section>
      <div>
        <h2 class="section-header">{{ (medicalAppealsSwitch ? 'MY_ELIGIBILITY_APPEALS' : 'MY_SUBMISSION_STATIC_30') | globalTranslate }}</h2>
        <hr>
          @if (appeals && appeals.length > 0) {
            <p>{{'MY_SUBMISSION_STATIC_32' | globalTranslate }}</p>
          }
          @if (isLinkedAcc && (appeals?.length === 0 || !appeals)) {
            <p>{{ (medicalAppealsSwitch ? 'MY_SUBMISSION_STATIC_31_EA' : 'MY_SUBMISSION_STATIC_31') | globalTranslate }}</p>
          }
          @if (!isLinkedAcc && !isPartnerPortal) {
            <p>{{'MY_SUBMISSION_EA_UNLINK' | globalTranslate }}<a [routerLink]="['/user-profile', 'case-link']">{{'LINK_CASE_TITLE' | globalTranslate }}</a> {{'MY_SUBMISSION_STATIC_5' | globalTranslate }}</p>
          }
          @if (appeals?.length > 0) {
            <div class="d-none d-lg-block">
              <ng-template #appealActionHeader>
                <span class="sr-only">Actions</span>
              </ng-template>
              <ngx-datatable class='bootstrap striped' #table [rows]='appeals' [columnMode]='"force"' [headerHeight]='"auto"'
                [footerHeight]='50' [rowHeight]='"auto"' [limit]="5" >
                <ngx-datatable-column name="{{'Submitted By' | globalTranslate }}">
                  <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                    {{ row.submittedBy }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{'MY_SUBMISSION_STATIC_33' | globalTranslate }}">
                  <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                    {{ row.wpAppnumber }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{'Appeal Reason' | globalTranslate }}">
                  <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                    @if (translatedLang === 'en') {
                      <div>{{ row.reason?.value | globalTranslate }}</div>
                    }
                    @if (translatedLang === 'sp') {
                      <div>{{ row.reason?.spValue }}</div>
                    }
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{'Submission Type' | globalTranslate }}">
                  <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                    @if (translatedLang === 'en') {
                      <div>{{ row.submissionType?.value | globalTranslate }}</div>
                    }
                    @if (translatedLang === 'sp') {
                      <div>{{ row.submissionType?.spValue }}</div>
                    }
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="{{'Date of Submission' | globalTranslate }}">
                  <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                    {{ row.submissionDate }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column [headerTemplate]="appealActionHeader">
                  <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                    <span class="hover-red">
                      <a class="btn btn-link hover-red" tabindex="0" (click)="onViewAppAppeal(row.tccAppnumber, row)" [attr.aria-label]="'VIEW_APPLICATION' | globalTranslate">
                        <i class="fa fa-search" aria-hidden="true"></i>
                        <span class="sr-only">{{'VIEW_APPLICATION' | globalTranslate }}</span>
                      </a>
                    </span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </div>
          }
          @if (appeals?.length > 0) {
            <div class="nh-table-mobile d-lg-none">
              @for (item of appeals; track item) {
                <div class="table-row mb-3 pb-3">
                  <div class="mobile-table-header">{{'Submitted By' | globalTranslate }}</div>
                  <hr>
                    <div class="mobile-table-data">{{ item.submittedBy }}</div>
                    <br>
                      <div class="mobile-table-header">{{'MY_SUBMISSION_STATIC_33' | globalTranslate }}</div>
                      <hr>
                        <div class="mobile-table-data">{{ item.wpAppnumber }}</div>
                        <br>
                          <div class="mobile-table-header">{{'Appeal Reason' | globalTranslate }}</div>
                          <hr>
                            @if (translatedLang === 'en') {
                              <div class="mobile-table-data">{{ item.reason?.value }}</div>
                            }
                            @if (translatedLang === 'sp') {
                              <div class="mobile-table-data">{{ item.reason?.spValue }}</div>
                            }
                            <br>
                              <div class="mobile-table-header">{{'Submission Type' | globalTranslate }}</div>
                              <hr>
                                @if (translatedLang === 'en') {
                                  <div class="mobile-table-data">{{ item.submissionType?.value }}</div>
                                }
                                @if (translatedLang === 'sp') {
                                  <div class="mobile-table-data">{{ item.submissionType?.spValue }}</div>
                                }
                                <br>
                                  <div class="mobile-table-header">{{'Date of Submission' | globalTranslate }}</div>
                                  <hr>
                                    <div class="mobile-table-data">{{ item.submissionDate }}</div>
                                    <br>
                                      <button class="btn btn-secondary btn-sm w-100" (click)="onViewAppAppeal(item.tccAppnumber, item)">
                                        {{'VIEW' | globalTranslate }}
                                      </button>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          </section>
                          <!--Medical Appeals start-->
                          @if (medicalAppealsSwitch) {
                            <section>
                              <div>
                                <h2 class="section-header">{{ 'MY_SUBMISSIONS_MA_HEADER' | globalTranslate }}</h2>
                                <hr>
                                  @if (medicalAppeals && medicalAppeals?.length > 0) {
                                    <p>{{'MY_SUBMISSIONS_MA_STATIC_TEXT_01' | globalTranslate }}</p>
                                  }
                                  @if (isLinkedAcc && (medicalAppeals?.length === 0 || !medicalAppeals)) {
                                    <p>{{'MY_SUBMISSIONS_MA_NODATA' | globalTranslate }}</p>
                                  }
                                  @if (!isLinkedAcc && !isPartnerPortal) {
                                    <p>{{'MY_SUBMISSIONS_MA_STATIC_UNLINK' | globalTranslate }}<a [routerLink]="['/user-profile', 'case-link']">{{'LINK_CASE_TITLE' | globalTranslate }}</a> {{'MY_SUBMISSION_STATIC_5' | globalTranslate }}</p>
                                  }
                                  @if (medicalAppeals?.length > 0) {
                                    <div class="d-none d-lg-block">
                                      <ng-template #medicalAppealActionHeader>
                                        <span class="sr-only">Actions</span>
                                      </ng-template>
                                      <ngx-datatable class='bootstrap striped' #table [rows]='medicalAppeals' [columnMode]='"force"' [headerHeight]='"auto"'
                                        [footerHeight]='50' [rowHeight]='"auto"' [limit]="5" >
                                        <ngx-datatable-column name="{{'Submitted By' | globalTranslate }}">
                                          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                            {{ row.submittedBy }}
                                          </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column name="{{'MY_SUBMISSION_MA_TABLE_HEADER_01' | globalTranslate }}">
                                          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                            {{ row.medAppealFor }}
                                          </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column name="{{'MY_SUBMISSION_MA_TABLE_HEADER_02' | globalTranslate }}">
                                          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                            {{ row.issueId}}
                                          </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column name="{{'Date of Submission' | globalTranslate }}">
                                          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                            {{ row.submissionDate }}
                                          </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column [headerTemplate]="medicalAppealActionHeader">
                                          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                            <span class="hover-red">
                                              <a class="btn btn-link hover-red" tabindex="0" (click)="viewMedicalAppealPDF(row.tccAppnumber)" [attr.aria-label]="'VIEW_APPLICATION' | globalTranslate">
                                                <i class="fa fa-search" aria-hidden="true"></i>
                                                <span class="sr-only">{{'VIEW_APPLICATION' | globalTranslate }}</span>
                                              </a>
                                            </span>
                                          </ng-template>
                                        </ngx-datatable-column>
                                      </ngx-datatable>
                                    </div>
                                  }
                                  @if (medicalAppeals?.length > 0) {
                                    <div class="nh-table-mobile d-lg-none">
                                      @for (item of medicalAppeals; track item) {
                                        <div class="table-row mb-3 pb-3">
                                          <div class="mobile-table-header">{{'Submitted By' | globalTranslate }}</div>
                                          <hr>
                                            <div class="mobile-table-data">{{ item.submittedBy }}</div>
                                            <br>
                                              <div class="mobile-table-header">{{'MY_SUBMISSION_MA_TABLE_HEADER_01' | globalTranslate }}</div>
                                              <hr>
                                                <div class="mobile-table-data">{{ item.medAppealFor }}</div>
                                                <br>
                                                  <div class="mobile-table-header">{{'MY_SUBMISSION_MA_TABLE_HEADER_02' | globalTranslate }}</div>
                                                  <hr>
                                                    <div class="mobile-table-data" >{{ item.issueId }}</div>
                                                    <br>
                                                      <div class="mobile-table-header">{{'Date of Submission' | globalTranslate }}</div>
                                                      <hr>
                                                        <div class="mobile-table-data">{{ item.submissionDate }}</div>
                                                        <br>
                                                          <button class="btn btn-secondary btn-sm w-100" (click)="viewMedicalAppealPDF(item.tccAppnumber)">
                                                            {{'VIEW' | globalTranslate }}
                                                          </button>
                                                        </div>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              </section>
                                            }
                                            <!-- QFR start -->
                                            <section>
                                              <div>
                                                <h2 class="section-header">{{'MY_SUBMISSION_STATIC_QFR' | globalTranslate }}</h2>
                                                <hr>
                                                  @if (!isLinkedAcc && !isPartnerPortal) {
                                                    <section>
                                                      <p>{{'MY_SUBMISSION_STATIC_4_QFR' | globalTranslate }}<a [routerLink]="['/user-profile', 'case-link']">{{'LINK_CASE_TITLE' | globalTranslate }}</a> {{'MY_SUBMISSION_STATIC_5' | globalTranslate }}</p>
                                                    </section>
                                                  }
                                                  @if (qfrRows && qfrRows.length > 0) {
                                                    <p>{{'MY_SUBMISSION_STATIC_10_QFR' | globalTranslate }}</p>
                                                  }
                                                  @if (isLinkedAcc && qfrRows?.length === 0) {
                                                    <p>{{'MY_SUBMISSION_STATIC_12_QFR'| globalTranslate }}
                                                    </p>
                                                  }
                                                  @if (qfrRows?.length > 0) {
                                                    <div class="d-none d-lg-block">
                                                      <ngx-datatable class='bootstrap striped' #table [rows]='qfrRows' [columnMode]='"force"' [headerHeight]='"auto"'
                                                        [footerHeight]='50' [rowHeight]='"auto"' [limit]="5" >
                                                        <ngx-datatable-column name="{{'Submitted By' | globalTranslate }}">
                                                          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                            {{ row.submittedBy }}
                                                          </ng-template>
                                                        </ngx-datatable-column>
                                                        <ngx-datatable-column name="{{'MY_SUBMISSION_STATIC_14_QFR' | globalTranslate }}">
                                                          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                            {{ row.wpAppnumber }}
                                                          </ng-template>
                                                        </ngx-datatable-column>
                                                        <ngx-datatable-column name="{{'Status' | globalTranslate }}">
                                                          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                            <div>{{'Submitted' | globalTranslate }}</div>
                                                          </ng-template>
                                                        </ngx-datatable-column>
                                                        <ngx-datatable-column name="{{'Date of Submission' | globalTranslate }}">
                                                          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                            {{ row.submissionDate }}
                                                          </ng-template>
                                                        </ngx-datatable-column>
                                                        <ngx-datatable-column name="{{'View' | globalTranslate }}">
                                                          <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                            <span class="hover-red">
                                                              <a class="btn btn-link hover-red" tabindex="0" (click)="onViewApp(row.tccAppnumber)" [attr.aria-label]="'VIEW_APPLICATION' | globalTranslate">
                                                                <i class="fa fa-search" aria-hidden="true"></i>
                                                                <span class="sr-only">{{'VIEW_APPLICATION' | globalTranslate }}</span>
                                                              </a>
                                                            </span>
                                                          </ng-template>
                                                        </ngx-datatable-column>
                                                      </ngx-datatable>
                                                    </div>
                                                  }
                                                  @if (qfrRows?.length > 0) {
                                                    <div class="nh-table-mobile d-lg-none">
                                                      @for (item of qfrRows; track item) {
                                                        <div class="table-row mb-3 pb-3">
                                                          <div class="mobile-table-header">{{'Submitted By' | globalTranslate }}</div>
                                                          <hr>
                                                            <div class="mobile-table-data">{{ item.submittedBy }}</div>
                                                            <br>
                                                              <div class="mobile-table-header">{{'MY_SUBMISSION_STATIC_14_QFR' | globalTranslate }}</div>
                                                              <hr>
                                                                @if (item.status === 'SB') {
                                                                  <div class="mobile-table-data">{{ item.wpAppnumber }}</div>
                                                                }
                                                                <br>
                                                                  <div class="mobile-table-header">{{'Status' | globalTranslate }}</div>
                                                                  <hr>
                                                                    <div class="mobile-table-data">{{'Submitted' | globalTranslate }}</div>
                                                                    <br>
                                                                      <div class="mobile-table-header">{{'Date of Submission' | globalTranslate }}</div>
                                                                      <hr>
                                                                        <div class="mobile-table-data">{{ item.submissionDate }}</div>
                                                                        <br>
                                                                          <button class="btn btn-secondary btn-sm w-100" (click)="onViewApp(item.tccAppnumber)">
                                                                            {{'VIEW' | globalTranslate }}
                                                                          </button>
                                                                        </div>
                                                                      }
                                                                    </div>
                                                                  }
                                                                </div>
                                                              </section>
                                                              <!-- QFR End -->
                                                              <section>
                                                                <div>
                                                                  <h2 class="section-header">{{'MY_SUBMISSION_STATIC_22' | globalTranslate }}</h2>
                                                                  <hr>
                                                                    <section>
                                                                      @if (showAFBLink) {
                                                                        <p>{{'MY_SUBMISSION_STATIC_23' | globalTranslate }}<a role="link" (click)="startApp()" (keydown.enter)="startApp()" (keydown.space)="startApp(); $event.preventDefault()" class="view-tennCare-title" tabindex="0">{{'Apply For Coverage' | globalTranslate }}.</a></p>
                                                                      }
                                                                      @if (!afbLinkToggle) {
                                                                        <p>{{'MY_SUBMISSION_STATIC_23' | globalTranslate }}<a role="link" (click)="startApp()" (keydown.enter)="startApp()" (keydown.space)="startApp(); $event.preventDefault()" class="view-tennCare-title" tabindex="0">{{'Apply For Coverage' | globalTranslate }}.</a></p>
                                                                      }
                                                                    </section>
                                                                    <div>
                                                                      @if (!isLinkedAcc && rows?.length > 0) {
                                                                        <p>{{'MY_SUBMISSION_STATIC_24' | globalTranslate }}</p>
                                                                      }
                                                                      @if (!isLinkedAcc) {
                                                                        <p>{{'MY_SUBMISSION_STATIC_25' | globalTranslate }}<a [routerLink]="['/user-profile', 'case-link']">{{'LINK_CASE_TITLE' | globalTranslate }}</a>.</p>
                                                                      }
                                                                      @if (!isLinkedAcc && rows?.length > 0) {
                                                                        <p>{{'MY_SUBMISSION_STATIC_26' | globalTranslate }}</p>
                                                                      }
                                                                    </div>
                                                                    @if (rows?.length === 0) {
                                                                      <p>{{'MY_SUBMISSION_STATIC_27' | globalTranslate }}</p>
                                                                    }
                                                                    @if (rows?.length > 0) {
                                                                      <p>{{'MY_SUBMISSION_STATIC_28' | globalTranslate }}</p>
                                                                    }
                                                                    @if (!isLinkedAcc && isPartnerPortal) {
                                                                      <p>{{'MY_SUBMISSION_STATIC_29' | globalTranslate }}</p>
                                                                    }
                                                                    <div class="d-lg-block d-none">
                                                                      <ng-template #actionHeader>
                                                                        <span class="sr-only">Actions</span>
                                                                      </ng-template>
                                                                      @if (rows?.length > 0) {
                                                                        <ngx-datatable class='bootstrap striped' #table [rows]='rows' [columnMode]='"force"' [headerHeight]='"auto"'
                                                                          [footerHeight]='50' [rowHeight]='"auto"' [limit]="5">
                                                                          @for (col of columns; track col) {
                                                                            <ngx-datatable-column [name]="col.name | globalTranslate" [prop]="col.prop">
                                                                            </ngx-datatable-column>
                                                                          }
                                                                          <ngx-datatable-column name="{{'APP_NUMBER' | globalTranslate }}">
                                                                            <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                                              @if (row.status === 'SB') {
                                                                                <span>{{ row.wpAppnumber }}</span>
                                                                              }
                                                                              @if (row.status === 'ST') {
                                                                                <span class="hover-red">
                                                                                  <a class="p-0 text-start btn btn-link btn-lg hover-red" tabindex="0" (click)="continueApp()">
                                                                                    <span>{{'COVERAGE_APPLICATION_CONTINUE' | globalTranslate }}</span>
                                                                                  </a>
                                                                                </span>
                                                                              }
                                                                            </ng-template>
                                                                          </ngx-datatable-column>
                                                                          <ngx-datatable-column name="{{'Status' | globalTranslate }}">
                                                                            <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                                              @if (row.status === 'SB') {
                                                                                <div>{{'Submitted' | globalTranslate }}</div>
                                                                              }
                                                                              @if (row.status === 'ST') {
                                                                                <div>{{'In Progress' | globalTranslate }}</div>
                                                                              }
                                                                            </ng-template>
                                                                          </ngx-datatable-column>
                                                                          <ngx-datatable-column name="{{'Date of Submission' | globalTranslate }}">
                                                                            <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                                              @if (row.status === 'SB') {
                                                                                <div>{{ row.submissionDate }}</div>
                                                                              }
                                                                              @if (row.status === 'ST') {
                                                                                <div>{{ row.lastAccessedDate }}</div>
                                                                              }
                                                                            </ng-template>
                                                                          </ngx-datatable-column>
                                                                          <ngx-datatable-column [headerTemplate]="actionHeader">
                                                                            <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex">
                                                                              @if (row.status === 'SB') {
                                                                                <span class="hover-red">
                                                                                  <a class="btn btn-link hover-red" tabindex="0" (click)="onViewApp(row.tccAppnumber)" [attr.aria-label]="'VIEW_APPLICATION' | globalTranslate">
                                                                                    <i class="fa fa-search" aria-hidden="true"></i>
                                                                                    <span class="sr-only">{{'VIEW_APPLICATION' | globalTranslate }}</span>
                                                                                  </a>
                                                                                </span>
                                                                              }
                                                                              @if (row.status === 'ST') {
                                                                                <span class="hover-red">
                                                                                  <a class="hover-red btn btn-link" tabindex="0" (click)="onDeleteApp(row)"><i class="fa fa-trash"></i></a>
                                                                                </span>
                                                                              }
                                                                            </ng-template>
                                                                          </ngx-datatable-column>
                                                                        </ngx-datatable>
                                                                      }
                                                                    </div>
                                                                    <div class="d-lg-none nh-table-mobile">
                                                                      @for (item of myApplications; track item) {
                                                                        <div class="table-row mb-3 pb-3">
                                                                          <div class="mobile-table-header">{{'Submitted By' | globalTranslate }}</div>
                                                                          <hr>
                                                                            <div class="mobile-table-data">{{ item.submittedBy }}</div><br>
                                                                            <div class="mobile-table-header">{{'Head of Household' | globalTranslate }}</div>
                                                                            <hr>
                                                                              <div class="mobile-table-data">{{ item.headOfHoushold }}</div><br>
                                                                              <div class="mobile-table-header">{{'APP_NUMBER' | globalTranslate }}</div>
                                                                              <hr>
                                                                                <div class="mobile-table-data">
                                                                                  @if (item.status === 'SB') {
                                                                                    <span>{{ item.wpAppnumber }}</span>
                                                                                  }
                                                                                  @if (item.status === 'ST') {
                                                                                    <span class="text-start hover-red">
                                                                                      <a class="text-start p-0 btn btn-link btn-lg hover-red w-100" tabindex="0" (click)="continueApp()">
                                                                                        <span>{{'COVERAGE_APPLICATION_CONTINUE' | globalTranslate }}</span>
                                                                                      </a>
                                                                                    </span>
                                                                                  }
                                                                                </div><br>
                                                                                <div class="mobile-table-header">{{'Status' | globalTranslate }}</div>
                                                                                <hr>
                                                                                  <div class="mobile-table-data">
                                                                                    @if (item.status === 'SB') {
                                                                                      <div>{{'Submitted' | globalTranslate }}</div>
                                                                                    }
                                                                                    @if (item.status === 'ST') {
                                                                                      <div>{{'In Progress' | globalTranslate }}</div>
                                                                                    }
                                                                                  </div><br>
                                                                                  <div class="mobile-table-header">{{'Date of Submission' | globalTranslate }}</div>
                                                                                  <hr>
                                                                                    <div class="mobile-table-data">
                                                                                      @if (item.status === 'SB') {
                                                                                        <div>{{ item.submissionDate }}</div>
                                                                                      }
                                                                                      @if (item.status === 'ST') {
                                                                                        <div>{{ item.lastAccessedDate }}</div>
                                                                                      }
                                                                                    </div><br>
                                                                                    @if (item.status === 'SB') {
                                                                                      <button class="btn btn-secondary btn-sm w-100" (click)="onViewApp(item.tccAppnumber)">
                                                                                        {{'VIEW' | globalTranslate }}
                                                                                      </button>
                                                                                    }
                                                                                    @if (item.status === 'ST') {
                                                                                      <button class="btn btn-secondary btn-sm w-100" (click)="onDeleteApp(item)">
                                                                                      {{'REMOVE' | globalTranslate }}</button>
                                                                                    }
                                                                                  </div>
                                                                                }
                                                                              </div>
                                                                            </div>
                                                                          </section>
                                                                        </div>
                                                                      </div>

                                                                      <div class="row">
                                                                      </div>
                                                                    </div>